const initialState = {
    user: '',
    userFullName: '',
    sowadmin: false,
    fetchingUserInfo: false,
    fetchedUserInfo: false,
    errorUserInfo: null,

    noData: false,
    sowsList: [],
    fetching: false,
    fetched: false,
    error: null,

    templatesList: [],
    fetchingTemplates: false,
    fetchedTemplates: false,
    errorTemplates: null
}

export function sowsReducer(state = initialState, action) {

    switch (action.type) {
        case "SET_USER": {
            return {
                ...state,
                user: action.payload.data.user,
                sowadmin: action.payload.data.sowadmin,
                fetchingUserInfo: true
            }
        }
        case "FETCH_USER_INFO_FULFILLED": {
            return {
                ...state,
                userFullName: action.payload.data.firstName + ' ' + action.payload.data.lastName,
                fetchingUserInfo: false,
                fetchedUserInfo: true
            }
        }
        case "FETCH_USER_INFO_ERROR": {
            return { ...state, fetchingUserInfo: false, errorUserInfo: action.payload.data }
        }

        case "FETCH_SOWS_LIST_TOKEN":
        case "FETCH_SOWS_LIST": {
            return { ...state, fetching: true, fetched: false, error: null }
        }
        case "FETCH_SOWS_LIST_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }
        case "FETCH_SOWS_LIST_FULFILLED": {    
            action.payload.data.projects.map((proj) => {
                var date = new Date(proj.createdOnDate);
                proj.createdOnDateDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear()

                date = new Date(proj.modifiedOnDate);
                proj.modifiedOnDateDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear()
            });

            return { ...state, fetching: false, fetched: true, noData: action.payload.data.projects.length == 0, sowsList: action.payload.data }
        }
        case "FETCH_SOW_ERROR": {
            return { ...state, error: null }
        }
        case "NODATA_ERROR_CLEAR": {
            return { ...state, noData: false }
        }

        case "FETCH_SOW_TEMPLATES_TOKEN":
        case "FETCH_SOW_TEMPLATES": {
            return { ...state, fetchingTemplates: true, fetchedTemplates: false, errorTemplates: null }
        }
        case "FETCH_SOW_TEMPLATES_REJECTED": {
            return { ...state, fetchingTemplates: false, errorTemplates: action.payload }
        }
        case "FETCH_SOW_TEMPLATES_FULFILLED": {

            var templates = Object.assign([], action.payload.data)

            templates.sort((a, b) => {
                if (a.projectTypeOrder > b.projectTypeOrder)
                    return 1
                else if (a.projectTypeOrder < b.projectTypeOrder)
                    return -1
                else
                    return 0
            })

            templates.map((template) => {
                template.projectTabs = template.projectTabs.filter((tab) => { return tab.active && !tab.deleted })
            })

            return { ...state, fetchingTemplates: false, fetchedTemplates: true, templatesList: templates }
        }
        case "FETCH_SOW_TEMPLATES_ERROR": {
            return { ...state, errorTemplates: null }
        }

        default:
            return state
    }
}
